import React, {ChangeEvent, useEffect, useState} from "react";
import {
    Button, Modal
} from "semantic-ui-react";

import {Link} from "react-router-dom";

interface Props {
    onClose: () => void;
}

const SurveySelectionExecuteStartModal = (props: Props) => {

    return (
        <Modal
            onClose={props.onClose}
            open={true}

            closeIcon>
            <Modal.Header>Выборка запущена!</Modal.Header>
            <Modal.Content>
                <p>Выборка была запущена на выполнение. Состояние выборки можно отслеживать в списке выборок или в разделе
                    "Системные задания".</p>
            </Modal.Content>
            <Modal.Actions>
                <Button
                    color={'grey'}
                    onClick={props.onClose}>
                    Закрыть
                </Button>
            </Modal.Actions>
        </Modal>);
}

export default SurveySelectionExecuteStartModal;